import BaseRepository from './base.repository';

class ChemotherapyTreatmentRepository extends BaseRepository {
  constructor() {
    super('/savanne');
  }

  findDetail(mainUnique) {
    return this.client.get(`/pil/${mainUnique}`);
  }
  
  findSymptomByMainUnique(mainUnique) {
    return this.client.get(`/symptoms/${mainUnique}`);
  }
}

export default new ChemotherapyTreatmentRepository();
